import React from 'react';
import {Button, Image, Modal} from 'react-bootstrap';
import {useNavigate} from "react-router-dom";

const SVipModal = ({visible, vipLevel, onClose}) => {

    const navigate = useNavigate();
    const [isMobile, setIsMobile] = React.useState(false);

    React.useEffect(() => {
        const handleResize = () => {
            // 使用 setTimeout 实现简单的防抖
            const timer = setTimeout(() => {
                setIsMobile(window.innerWidth < 768);
            }, 100);

            return () => clearTimeout(timer);
        };

        handleResize(); // 初始化时调用
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (

        <Modal show={visible} centered onHide={onClose}
               style={{'--bs-modal-margin': '2rem', '--bs-modal-bg': 'transparent',}}>
            <Modal.Body>
                    <Image src={'/images/open_vip_bg.png'} style={{ width: '100%'}} />
                    <div className={'text-center p-lg-5 p-3'} style={{background: '#070000', borderBottomLeftRadius: '8px',borderBottomRightRadius: '8px',}}>
                        <p style={{color: '#B4BFC5', fontSize: '14px',}}>您正在使用<span
                            style={{color: '#AB7433', fontWeight: 'bold', fontSize: '16px',}}>高级工作流</span>，
                            需要{vipLevel>1?"SVIP":"VIP"}会员权限。开通会员即可享受全部高级功能，提升创作效率。
                        </p>
                        <p style={{
                            color: '#B4BFC5',
                            fontSize: '14px',
                            background: '#211C1C',
                            borderRadius: '8px',
                            padding: '14px 8px',
                        }}><Image src={'/images/open_vip_icon1.svg'} width={'17px'}
                                  style={{marginRight: '26px',}}/>解锁<span
                            style={{color: '#AB7433', fontWeight: 'bold', fontSize: '16px',}}>全部高级工作流</span>，提升AI创作能力
                        </p>
                        <p style={{
                            color: '#B4BFC5',
                            fontSize: '14px',
                            background: '#211C1C',
                            borderRadius: '8px',
                            padding: '14px 8px',
                        }}><span><Image src={'/images/open_vip_icon2.svg'} width={'20px'}
                                        style={{marginRight: '26px',}}/></span>享受<span
                            style={{color: '#AB7433', fontWeight: 'bold', fontSize: '16px',}}>优先处理权限</span>，工作流复制更快捷
                        </p>
                        <Button style={{
                            background: 'linear-gradient(90deg, #AF7A3C, #E4A358)',
                            padding: '12px 48px',
                            borderRadius: '8px',
                            color: '#060606',
                            fontSize: '16px',
                            border: 'none',
                        }} onClick={()=>{  navigate('/vipCenter')}}>
                            立即解锁{vipLevel>1?"SVIP":"VIP"}特权
                        </Button>
                    </div>


            </Modal.Body>
        </Modal>

    );
};

export default SVipModal;